module.exports = __webpack_public_path__ + "img/Logo-Vse.-Zaimi.a0048205.svg";